import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(
    createStyles({
        item: {
            marginBottom: 20,
            width: '100%'
        }
    })
)
